const showLoader = () => {
    document.getElementById("loading").classList.remove('hide');
}
const hideLoader = () => {
    document.getElementById("loading").classList.add('hide');
}

module.exports ={
    showLoader:showLoader,
    hideLoader:hideLoader
};


